var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.096 5.468 1.546-1.298a2.501 2.501 0 0 1 2.797-.283l.142-.052a5.495 5.495 0 0 1 1.723-.33 4 4 0 0 0-5.627-.484L4.975 6.968l4.12-1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.835 14.995a2.697 2.697 0 1 1 5.395 0 2.697 2.697 0 0 1-5.395 0Zm2.698-1.447a1.447 1.447 0 1 0 0 2.894 1.447 1.447 0 0 0 0-2.894Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02 14.995a1.447 1.447 0 0 1 2.311-1.161.625.625 0 0 0 .747-1.002 2.697 2.697 0 1 0-.016 4.34.625.625 0 0 0-.74-1.009 1.447 1.447 0 0 1-2.302-1.168Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8.995a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4H7Zm10 1.5H7a2.5 2.5 0 0 0-2.5 2.5v4a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5v-4a2.5 2.5 0 0 0-2.5-2.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14.607 6.654-2.31.841H7.91l6.183-2.25a4 4 0 0 1 5.127 2.39l.143.393a5.465 5.465 0 0 0-1.892-.513 2.501 2.501 0 0 0-2.865-.86Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.4c5e89e014afce20b68e7ec0cbffd2d1.svg";
export { ForwardRef as ReactComponent };